var map = {
	"./apps-active@2x.png": 79277,
	"./apps@2x.png": 68784,
	"./btn-help-question-mark@2x.png": 9454,
	"./checkmark@2x.png": 52045,
	"./chevron@2x.png": 48198,
	"./customers-active@2x.png": 48065,
	"./customers@2x.png": 2206,
	"./discounts-active@2x.png": 98203,
	"./discounts@2x.png": 99598,
	"./drag-vertical@2x.png": 49951,
	"./editor-active@2x.png": 28096,
	"./editor@2x.png": 78955,
	"./emptystate/customers@2x.png": 80521,
	"./emptystate/orders@2x.png": 90821,
	"./emptystate/payments@2x.png": 66253,
	"./emptystate/shipments@2x.png": 51473,
	"./events/discount-updated@2x.png": 49982,
	"./events/hold-off@2x.png": 25665,
	"./events/hold-on@2x.png": 55796,
	"./events/items-added@2x.png": 21856,
	"./events/items-canceled@2x.png": 49632,
	"./events/items-changed@2x.png": 69713,
	"./events/note-added@2x.png": 33597,
	"./events/notification@2x.png": 86944,
	"./events/order-canceled@2x.png": 65780,
	"./events/order-created@2x.png": 96738,
	"./events/order-submitted@2x.png": 55244,
	"./events/payment@2x.png": 87638,
	"./events/return-created@2x.png": 95275,
	"./events/shipment-created@2x.png": 44772,
	"./events/shipment-updated@2x.png": 46732,
	"./feedback-active@2x.png": 65774,
	"./feedback@2x.png": 93026,
	"./filter@2x.png": 92438,
	"./frameworks/gatsby@2x.png": 55008,
	"./frameworks/react@2x.png": 46890,
	"./frameworks/vue@2x.png": 84650,
	"./help-link-icon-gray@2x.png": 94059,
	"./help-link-icon-purple@2x.png": 27011,
	"./home-active@2x.png": 82129,
	"./home@2x.png": 23614,
	"./hosting/cloudfare@2x.png": 69835,
	"./hosting/netlify@2x.png": 39188,
	"./hosting/vercel@2x.png": 8750,
	"./image@2x.png": 12716,
	"./long-text-active@2x.png": 48776,
	"./long-text@2x.png": 56231,
	"./migration/shopify@2x.png": 75741,
	"./nav/apps-active@2x.png": 93847,
	"./nav/apps@2x.png": 19029,
	"./nav/chevron@2x.png": 65421,
	"./nav/customers-active@2x.png": 93632,
	"./nav/customers@2x.png": 52543,
	"./nav/developer-active@2x.png": 73295,
	"./nav/developer@2x.png": 30907,
	"./nav/discounts-active@2x.png": 11328,
	"./nav/discounts@2x.png": 82027,
	"./nav/home-active@2x.png": 95653,
	"./nav/home@2x.png": 62021,
	"./nav/integrations-active@2x.png": 72784,
	"./nav/integrations@2x.png": 31258,
	"./nav/orders-active@2x.png": 7058,
	"./nav/orders@2x.png": 64909,
	"./nav/products-active@2x.png": 27965,
	"./nav/products@2x.png": 25828,
	"./nav/reporting-active@2x.png": 1734,
	"./nav/reporting@2x.png": 66806,
	"./nav/settings-active@2x.png": 95601,
	"./nav/settings@2x.png": 59230,
	"./nav/storefront-active@2x.png": 16990,
	"./nav/storefront@2x.png": 97025,
	"./nav/subscriptions-active@2x.png": 52408,
	"./nav/subscriptions@2x.png": 83713,
	"./notification@2x.png": 63609,
	"./orders-active@2x.png": 88092,
	"./orders@2x.png": 75086,
	"./payment/affirm@2x.png": 77812,
	"./payment/amazon@2x.png": 24035,
	"./payment/amex@2x.png": 20868,
	"./payment/bancontact@2x.png": 34455,
	"./payment/cirrus@2x.png": 85756,
	"./payment/dinersclub@2x.png": 28569,
	"./payment/discover@2x.png": 9042,
	"./payment/google@2x.png": 14582,
	"./payment/ideal@2x.png": 96378,
	"./payment/jcb@2x.png": 5048,
	"./payment/klarna@2x.png": 83091,
	"./payment/maestro@2x.png": 30408,
	"./payment/manual-bank@2x.png": 56766,
	"./payment/manual-card@2x.png": 71754,
	"./payment/manual-cash@2x.png": 10807,
	"./payment/manual-check@2x.png": 34176,
	"./payment/manual-gift@2x.png": 45631,
	"./payment/mastercard@2x.png": 55358,
	"./payment/paypal@2x.png": 54446,
	"./payment/paysafecard@2x.png": 23228,
	"./payment/resolve@2x.png": 78533,
	"./payment/twint@2x.png": 23719,
	"./payment/visa@2x.png": 96588,
	"./products-active@2x.png": 25397,
	"./products@2x.png": 50989,
	"./reports-active@2x.png": 22819,
	"./reports@2x.png": 37837,
	"./select-active@2x.png": 69445,
	"./select@2x.png": 80066,
	"./settings-active@2x.png": 58094,
	"./settings@2x.png": 96985,
	"./short-text-active@2x.png": 51018,
	"./short-text@2x.png": 75851,
	"./store-active@2x.png": 13213,
	"./store@2x.png": 79907,
	"./storefront-customize@2x.png": 34664,
	"./storefront/builder@2x.png": 39593,
	"./storefront/editor/check@2x.png": 2182,
	"./storefront/editor/copy@2x.png": 86785,
	"./storefront/editor/expand@2x.png": 18460,
	"./storefront/editor/home@2x.png": 67372,
	"./storefront/editor/laptop@2x.png": 51530,
	"./storefront/editor/monitor@2x.png": 80533,
	"./storefront/editor/phone@2x.png": 74339,
	"./storefront/editor/plus@2x.png": 82742,
	"./storefront/editor/redo@2x.png": 84339,
	"./storefront/editor/settings@2x.png": 95712,
	"./storefront/editor/store@2x.png": 15749,
	"./storefront/editor/tablet@2x.png": 44968,
	"./storefront/editor/trash@2x.png": 12185,
	"./storefront/editor/undo@2x.png": 67937,
	"./storefront/next@2x.png": 58654,
	"./toggle-active@2x.png": 2023,
	"./toggle@2x.png": 47423,
	"./wallet-active@2x.png": 56345,
	"./wallet@2x.png": 5166,
	"./warning@2x.png": 76080
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54733;